export default function delayAction(callback: Function, delayTime: number = 350) {
    setTimeout(() => {
      callback();
    }, delayTime);
  }